export default "__VITE_ASSET__b16179eb__"